import { doBetsStore, roundsInfoStore } from '../../store';
import { getGameCanvasStandards } from '../../helpers/gameCanvasHelper';
import { deepCopy, freeBetStore, userInfoStore } from '@pascal/pascal-core';
import { betBlocksByTypes } from '../../constants/canvasConfig';
import { rangeBetBlockSize } from '../../constants/canvasConfig';
import { soundService, soundTypes } from '../../services';
import { notificationStore, BetResponseCode } from '@pascal/pascal-core';
import { INVALID_MIN_ODD_RESPONSE_CODE } from '../../enums/additionalResponseCodes';

export const CanvasButton = (x, point, click, additionalProps, w = 100, h = 50, isDisable = false) => {
  const { canvas } = getGameCanvasStandards();
  const clicked = false;
  const getY = () => {
    const { concentrationDiff } = roundsInfoStore;
    const diff = h === rangeBetBlockSize.height ? h : 0;
    return canvas.height - (point * 10 - concentrationDiff) - diff;
  };
  const getX = () => {
    const { presentPoint } = roundsInfoStore;
    return presentPoint.x + x;
  };

  const getRange = () => ({
    start: {
      get x() {
        return getX();
      },
      get y() {
        return getY();
      },
    },
    end: {
      get x() {
        return getX() + w;
      },
      get y() {
        return getY() + h;
      },
    },
  });

  const isInRange = (x, y) => {
    const range = getRange();
    return range.start.x < x && range.end.x > x && range.start.y < y && range.end.y > y;
  };

  function onclick() {
    this.clicked = !this.clicked;
    click.call(this);
  }

  return {
    isDisable,
    clicked,
    w,
    h,
    get x() {
      return getX();
    },
    get y() {
      return getY();
    },
    getRange,
    isInRange,
    onclick,
    ...additionalProps,
  };
};

export const RowBetBlock = (point, rowBlockIndexes) => {
  const x = 400;

  const isRowClicked = () => {
    const { betBlocks } = doBetsStore;
    const betBlocksCopy = deepCopy(betBlocks);

    return rowBlockIndexes.every((index) => {
      return betBlocksCopy[index].clicked;
    });
  };

  const rowBlockClick = () => {
    const { betBlocks } = doBetsStore;
    const isRowBet = !isRowClicked();

    rowBlockIndexes.forEach((index) => {
      if (!(betBlocks[index].clicked === isRowBet)) {
        if (!betBlocks[index].isDisable) {
          const { activeFreeBet } = freeBetStore;
          if (!activeFreeBet?.id && doBetsStore.betAmount * rowBlockIndexes.length > userInfoStore.balance) {
            notificationStore.setNotificationType({ responseCode: BetResponseCode.InsufficientFunds });
            return;
          }
          betBlocks[index].onclick(rowBlockIndexes);
        }
      }
    });

    soundService.play(soundTypes.click);
  };

  const additionalProps = {
    rowBlockIndexes,
    isRowClicked,
  };

  return CanvasButton(x, point, rowBlockClick, additionalProps);
};

export const BetBlock = (type, roundId, x, point, odd, w = 100, h = 50, isDisable = false) => {
  const amount = null;

  function fixBetAmount() {
    if (this.isDisable) {
      this.clicked = !this.clicked;
      notificationStore.setNotificationType({ responseCode: INVALID_MIN_ODD_RESPONSE_CODE });
      return;
    }
    if (this.clicked) {
      const { betAmount, getBlockCurrentTotalAmount } = doBetsStore;
      const { activeFreeBet } = freeBetStore;
      if (!activeFreeBet?.id && getBlockCurrentTotalAmount() + betAmount > userInfoStore.balance) {
        this.clicked = !this.clicked;
        notificationStore.setNotificationType({ responseCode: BetResponseCode.InsufficientFunds });
        return;
      } else {
        this.amount = betAmount;
      }
    } else {
      this.amount = null;
    }

    soundService.play(soundTypes.click);
  }

  function getDrawingConfigs() {
    if (this.clicked) {
      return betBlocksByTypes[type].clicked;
    }
    return betBlocksByTypes[type].default;
  }

  const additionalProps = {
    odd,
    type,
    point,
    amount,
    roundId,
    getDrawingConfigs,
  };

  return CanvasButton(x, point, fixBetAmount, additionalProps, w, h, isDisable);
};
